import React from 'react';
import { dashboardMenu, demoPages, layoutMenu } from '../menu';
import DashboardHeader from '../pages/common/Headers/DashboardHeader';
import DashboardBookingHeader from '../pages/common/Headers/DashboardBookingHeader';
import DefaultHeader from '../pages/common/Headers/DefaultHeader';

const headers = [
	{ path: demoPages.login.path, element: null, exact: true },
	{ path: '/google-phone-number', element: null, exact: true },
	{ path: demoPages.signUp.path, element: null, exact: true },

	// {
	// 	path: demoPages.login.path,
	// 	element: <Login />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.signUp.path,
	// 	element: <Login isSignUp />,
	// 	exact: true,
	// },

	{
		path: demoPages.privacy.path,
		element: null,
		exact: true,
	},
	{
		path: demoPages.forgot.path,
		element: null,
		exact: true,
	},
	{
		path: demoPages.mobileotp.path,
		element: null,
		exact: true,
	},

	{
		path: demoPages.HHome.path,
		element: null,
		exact: true,
	},

	{
		path: demoPages.terms.path,
		element: null,
		exact: true,
	},
	{
		path: demoPages.changepw.path,
		element: null,
		exact: true,
	},
	{
		path: demoPages.guestuser.path,
		element: null,
		exact: true,
	},

	{
		path: layoutMenu.view_productvwl.path,
		element: null,
		exact: true,
	},

	{
		path: `${layoutMenu.view_productvwl.path}/*`,
		element: null,
		exact: true,
	},

	{
		path: layoutMenu.view_servwl.path,
		element: null,
		exact: true,
	},

	{
		path: `${layoutMenu.view_servwl.path}/*`,
		element: null,
		exact: true,
	},

	{ element: <DashboardHeader />, exact: true },
	{
		path: `*`,
		element: <DefaultHeader />,
	},
];

export default headers;
